import { Fragment } from 'react'
import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import type { NormalizedCompanyColorScheme } from 'zens-store'
import { Color, Radius, Spacing, Text } from 'zens-storybook'

import { legendItemsFromColorScheme } from './colorscheme'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.simplyWhite,
    padding: Spacing.S,
    borderRadius: Radius.M,
    borderColor: Color.calmGrey,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    color: Color.calmGrey,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: Spacing.L,
  },
  bars: {
    flexDirection: 'row',
    borderRadius: Radius.XS,
    overflow: 'hidden',
  },
  bar: {
    height: 14,
    width: 30,
    marginRight: Spacing.XS,
  },
  labelText: {
    lineHeight: 14,
    marginRight: Spacing.S,
  },
  noSensor: {
    backgroundColor: Color.calmGrey,
  },
})

interface Props extends ViewProps {
  colorScheme: NormalizedCompanyColorScheme
}

const InsightsLegendLive = (props: Props) => {
  const { colorScheme, style, ...otherProps } = props
  const legendItems = legendItemsFromColorScheme(colorScheme)

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text style={styles.title} numberOfLines={1}>
        <Trans>Workspace status</Trans>
      </Text>
      <View style={styles.content}>
        {legendItems.map((item) => (
          <Fragment key={item.key}>
            <View style={[styles.bar, { backgroundColor: item.color }]} />
            <Text style={styles.labelText} numberOfLines={1} level={7}>
              <Trans>{item.label}</Trans>
            </Text>
          </Fragment>
        ))}
        <View style={[styles.bars, styles.bar, styles.noSensor]} />
        <Text numberOfLines={1} level={7}>
          <Trans>Unknown</Trans>
        </Text>
      </View>
    </View>
  )
}

export default InsightsLegendLive
